import { CommsRepo } from "../comms.repo";
import * as _ from "lodash";

class newCommController implements angular.IOnInit {
  public message: string;
  public type: string;
  public isLoading = false;
  private fileControl: HTMLInputElement;
  public file = null;
  public messageTypes = ["General", "Warning", "Urgent"];
  public fileName = "";

  /** @ngInject */
  constructor(
    private fileRepo: CommsRepo,
    private $state: angular.ui.IStateService,
    private $stateParams: angular.ui.IStateParamsService,
    private notifyjs: any,
    private $scope: angular.IScope
  ) {}

  $onInit() {
    this.fileControl = document.getElementById(
      "uploadFile"
    ) as HTMLInputElement;
    this.fileControl.addEventListener(
      "change",
      this.uploadFileEventChange.bind(this)
    );
    this.fileControl.addEventListener("click", this.resetInput.bind(this));
  }

  save() {
    this.isLoading = true;
    this.fileRepo
      .saveComm(this.message, this.type, this.file)
      .catch((err) => this.notifyjs(err))
      .finally(() => {
        this.isLoading = false;
        this.message = "";
        this.type = "";
        this.$state.go("root.communication");
      });
  }

  uploadFileEventChange(event) {
    this.file = event.target.files[0];
    this.fileName = "File name: " + event.target.files[0].name;
    this.$scope.$apply();
  }

  openFile() {
    document.getElementById("uploadFile").click();
  }

  cancel() {
    this.message = "";
    this.type = "";
    this.$state.go("root.communication");
  }

  resetInput(event) {
    event.target.value = null;
    return false;
  }

  getFileName() {
    if (this.file) {
      return this.fileName;
    }
    return "";
  }
}

export const newComm: angular.IComponentOptions = {
  template: require("./newComm.html"),
  controller: newCommController,
};



// WEBPACK FOOTER //
// ./src/app/communications/newComm/newComm.ts